module.exports = __webpack_public_path__ + "img/3화_3-1(2).1c7248f5.png";